import { render, staticRenderFns } from "./ProductList_comp.vue?vue&type=template&id=29d1d45a&scoped=true&"
import script from "./ProductList_comp.vue?vue&type=script&lang=js&"
export * from "./ProductList_comp.vue?vue&type=script&lang=js&"
import style0 from "./ProductList_comp.vue?vue&type=style&index=0&id=29d1d45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1d45a",
  null
  
)

export default component.exports